import { INLINES } from "@contentful/rich-text-types";

export const contentfulOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: (node, next) => {
      return `<span class="text-accent"><a href=${node.data.uri}>${next(
        node.content
      )}</a></span>`;
    },
  },
};
